module.exports = __webpack_public_path__ + "images/category_lp/brand/new/store_images/2_918b55d605f5f33db5c986d7c9bdd893.png";